export default "__VITE_ASSET__ChE06$Tl__"